import { render, staticRenderFns } from "./DocumentActionGrid.vue?vue&type=template&id=a739a234&scoped=true&"
import script from "./DocumentActionGrid.vue?vue&type=script&lang=js&"
export * from "./DocumentActionGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a739a234",
  null
  
)

export default component.exports